var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iq-fancy-box iq-works-box text-center"},[_c('div',{staticClass:"iq-icon"},[_vm._t("cardMedia")],2),_vm._v(" "),_c('div',{staticClass:"fancy-content"},[_vm._t("cardBody")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }